<template>
  <div id="side-menu">
    <v-navigation-drawer
      permanent
      :width="menu_width"
      class="flex-md-column"
      color="#ffffff"
      app
      id="sidemenu"
    >
      <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
        <div>
          <div id="sidemenu-connection-status">
             <span v-if="this.$store.state.system_connection_state.service_is_connected"
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #9c6;
                                     border-radius: 20px;
                                     display: inline-block;
                                     margin-left: 30px;
"
            >
            </span>
            <span v-else
              style="height: 20px;
                     width: 20px;
                     background-color: #fa4848;
                     border-radius: 20px;
                     display: inline-block;"
            >
            </span>
          </div>
          <div id="sidemenu-icon-container">
            <v-icon size="100" color="#ffffff">
              $icon_logo
            </v-icon>

          </div>
          <v-tabs vertical>
            <template v-for="item in $store.state.menu_items">
              <v-tab
                  v-if="accessible_links.includes(item.link)"
                  align-with-title
                  :grow="true"
                  :fixed-tabs="false"
                  link :to="$i18nRoute({name: item.name})"
                  :key="item.name"
                  style="display: flex;
                        justify-content: flex-start;
                        padding-left: 10%;
                        height: 70px;
                        max-width: 100%;
                        width: 100%"
              >
                  <v-icon left color="currentColor" size="26px">
                  ${{item.icon_name}}
                  </v-icon>
                <span class="tab-font">{{$i18n.t(`side_menu.${item.link}`)}}</span>
              </v-tab>
            </template>
          </v-tabs>
        </div>
<!--        <template>-->
<!--    <v-row justify="center">-->
<!--      <v-dialog-->
<!--        v-model="dialog"-->
<!--        persistent-->
<!--        max-width="380"-->
<!--      >-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-btn-->
<!--              class="white&#45;&#45;text mr-1 ml-1"-->
<!--              color="#DBEAF1"-->
<!--              elevation="0"-->
<!--              height="42"-->
<!--              width="80%"-->
<!--              v-bind="attrs"-->
<!--              v-on="on"-->
<!--          >-->
<!--            <span class="main_color button-font">{{ $i18n.t('general.system_reboot')}}</span>-->

<!--          </v-btn>-->
<!--          </template>-->
<!--          <v-card>-->
<!--            <v-card-title class="text-h5" align="center">-->
<!--              {{ $i18n.t('general.system_reboot_offer')}}-->
<!--            </v-card-title>-->
<!--            <v-card-text>-->
<!--              {{ $i18n.t('general.system_reboot_sure') }}-->
<!--            </v-card-text>-->
<!--            <v-card-actions style="justify-content: space-between">-->
<!--              <v-spacer></v-spacer>-->
<!--              <v-btn-->
<!--                style="margin-right: 90px; color:white"-->
<!--                color="red"-->
<!--                class="button-font"-->
<!--                @click="dialog = false"-->
<!--              >-->
<!--                Отменить-->
<!--              </v-btn>-->
<!--                <v-btn-->
<!--                  style="color: white"-->
<!--                  color="primary"-->
<!--                  class="button-font"-->
<!--                  @click="send_system_reload_message(); dialog=false"-->
<!--                >-->
<!--                  Подтвердить-->
<!--                </v-btn>-->
<!--              </v-card-actions>-->
<!--              </v-card>-->
<!--            </v-dialog>-->
<!--          </v-row>-->
<!--      </template>-->
        <div style="display: flex; justify-content: center; margin-bottom: 50px; margin-top: 50px">
          <v-btn
            color="#207EA9"
            @click="logout"
            class="white--text logout-button"
            min-height="42px"
            width="80%"
          >
            <span class="button-font">{{$i18n.t('side_menu.logout')}}</span>
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
// import axios from 'axios'

import router from "@/router";
import {mapActions, mapGetters} from "vuex";
import {common_funcs} from "@/mixins/common";
// import store from "@/store";


export default {
  mixins: [common_funcs],
  name: 'SideMenu',
  props: ['menu_width'],
  data: function () {
    return {
        dialog: false,

    }
  },
  methods: {
    logout: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/users/logout', data: {}, method: 'POST'})
      .then(resp => {
        if (resp.data.result === 'ok') {
          let default_user = t.$store.state.default_user
          t.changeUserData(default_user)
          router.push(t.$i18nRoute({name: 'Login'}))
          // router.push({name: 'Login', params: {locale: t.$i18n.locale}})
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    link_with_params: function(name) {
      return {name: name, params: {locale: this.$i18n.locale}}
    },
    ...mapActions(['changeUserData']),
    ...mapGetters(['systemConnectionState', "systemParams"])

  },
  computed: {
    available_items: function () {
      return null
    },
    accessible_links: function () {
      console.log(this.$store.state.user.access_to_tabs)
      console.log(this.$store.state.system_connection_state.service_is_connected)
      return this.$store.state.user.access_to_tabs
    }
  },
  service_connection_state: function () {
    console.log(this.systemConnectionState.service_is_connected)
      if (this.systemConnectionState.service_is_connected) {
        console.log(this.systemConnectionState.service_is_connected)
        return true
      } else {
        console.log(false)
        return false
      }
    },
};
</script>
<style lang="scss" scoped>

#sidemenu-icon-container {
  display: flex;
  justify-content: center;
  //margin-top: 5px;
  margin-bottom: 15px;
}
#sidemenu-connection-status {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 15px;
  margin-right: 20px;
}
.sidemenu-icon {
  display: flex;
  align-items: center;
}
.logout-button {
  border-radius: 4px;
}
.tab-font {
  font-family: Roboto,serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;

  /* identical to box height */
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  color: currentColor;
}
</style>
